module.exports = __webpack_public_path__ + "static/img/asset.9f5f45a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/asset.png
// module id = 6kPx
// module chunks = 0